import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ManagementService } from '../../services/management.service';
import { ModalLoadingComponent } from '../../../shared/modals/modal-loading/modal-loading.component';
import { ModalSuccessComponent } from '../../../shared/modals/modal-success/modal-success.component';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';
import { CountryService } from '../../../services/country.service';

@Component({
  selector: 'app-country-register-modal',
  templateUrl: './country-register-modal.component.html',
  styleUrl: './country-register-modal.component.scss',
  providers: [DialogService],
})
export class CountryRegisterModalComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() registerComplete = new EventEmitter<void>();

  isDisabled: boolean = true;
  country: string | null = null;
  codeCountry: string | null = null;
  phoneCode: number | null = null;

  hasInteracted: { [key: string]: boolean } = {
    country: false,
    codeCountry: false,
    phoneCode: false,
  };

  constructor(
    private managementService: ManagementService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.resetForm();
  }

  onChangeInput(event: any, type: string) {
    this.hasInteracted[type] = true;
    switch (type) {
      case 'country':
        this.country = event;
        break;
      case 'codeCountry':
        this.codeCountry = event;
        break;
      case 'phoneCode':
        this.phoneCode = event;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.validateForm();
  }

  validateForm() {
    this.isDisabled = !(this.country && this.phoneCode && this.codeCountry);
  }

  onRegister() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    const request = {
      nameCountry: this.country,
      codeCountry: this.codeCountry,
      phoneCode: this.phoneCode,
    };

    const formData = new FormData();

    const appendIfDefined = (key: string, value: any) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    };

    Object.entries(request).forEach(([key, value]) =>
      appendIfDefined(key, value)
    );

    this.managementService.createCountry(formData).subscribe({
      next: (response) => {
        loadingRef.close();
        const ref = this.dialogService.open(ModalSuccessComponent, {
          header: '',
          data: {
            text: 'Tu registro ha sido realizado con éxito.',
            title: '¡Éxito!',
            icon: 'pi pi-check-circle',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.registerComplete.emit();
        this.closeDialog();
      },

      error: (err) => {
        loadingRef.close();

        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text:
              err.error?.error ||
              'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
            title: '¡Lo sentimos!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        // this.resetForm();
        this.closeDialog();
      },
    });
    // this.closeDialog();
  }

  resetForm() {
    this.country = null;
    this.codeCountry = null;
    this.phoneCode = null;

    this.hasInteracted = {
      country: false,
      codeCountry: false,
      phoneCode: false,
    };
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.resetForm();
  }
}
